import { render, staticRenderFns } from "./CardErosion.vue?vue&type=template&id=5b2811e1&scoped=true"
import script from "./CardErosion.vue?vue&type=script&lang=js"
export * from "./CardErosion.vue?vue&type=script&lang=js"
import style0 from "./CardErosion.vue?vue&type=style&index=0&id=5b2811e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2811e1",
  null
  
)

export default component.exports